import  { useState } from 'react'

import useApiResource from 'src/api'
import { useParcelStore } from 'src/store/parcel'

type TransactorFnType={
    path?:string,payload:Object
}
export const useTransactor = () => {
const [loading, setLoading] = useState(false)
const [message, setMessage] = useState('')
const setRoomData = useParcelStore(state => state.setRoomData)
const apiResource = useApiResource()
const [data, setData] = useState('')

  const  initiateRoomFn = async({payload}:TransactorFnType) =>{
    try{
      setLoading(true)
      const {data} = await apiResource({path:`${import.meta.env.VITE_TRANSACTOR_URL}document/room/initialize`,method:'post',payload})
      setLoading(false)
      if(data){
        setData(data)
        setRoomData(data?.data || null)
      }
      setMessage('')
    }catch(e){
      console.error('Error onStartTransactorFn', e)
      setLoading(false)
      throw new Error(`${e}`)
    }
  }
  return {
    loading,
    setLoading,
    message,
    data,
    initiateRoomFn
  }
}